import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CoreTargetService } from '../core/services/target.service';
import { LocalStorageService } from '../core/services/local-storage.service';
import { getCurrentEnv } from '../core/http/env-utils';

/**
 * Adds SEO query params when calling SEO endpoints:
 *  - language (localStorage → default 'en')
 *  - shopID (CoreTargetService)
 *
 * Detection:
 *  - Either the request path starts with '/seo/' (pre-rewrite), OR
 *  - The absolute URL starts with the configured SEO base (post-rewrite).
 */
export const SeoParamsInterceptor: HttpInterceptorFn = (req, next) => {
  const localStorageService = inject(LocalStorageService);
  const env = getCurrentEnv();
  const seoBase = env.seo; // e.g., https://seo.behamics.com

  // Support both pre- and post-rewrite forms
  const path = (req.url.split('?')[0] || '').trim();
  const isPreRewrite = path.startsWith('/seo/');
  const isPostRewrite =
    typeof seoBase === 'string' && req.url.startsWith(seoBase);
  const isSeo = isPreRewrite || isPostRewrite;
  if (!isSeo) return next(req);

  const language: string = localStorageService.get('language') || 'en';
  const shopID: string =
    inject(CoreTargetService).getSelectedTarget('target') || '';

  const hasLang = req.params.has('language');
  const hasShop = req.params.has('shopID');
  if (hasLang && hasShop) return next(req);

  const setParams: Record<string, string> = {};
  if (!hasLang) setParams['language'] = language;
  if (!hasShop) setParams['shopID'] = shopID;

  return next(req.clone({ setParams }));
};
